<template>
	<div>
		<!-- banner宣传-->
		<section class="main-slider">
			<div class="swiper-container thm-swiper__slider" data-swiper-options='{"slidesPerView": 1, "loop": true,
                      "effect": "fade",
                      "pagination": {
                      "el": "#main-slider-pagination",
                      "type": "bullets",
                      "clickable": true
                      },
                      "navigation": {
                      "nextEl": "#main-slider__swiper-button-next",
                      "prevEl": "#main-slider__swiper-button-prev"
                      },
                      "autoplay": {
                      "delay": 7000
                      }}'>
				<div class="swiper-wrapper">

					<div class="swiper-slide">
						<div class="image-layer "
							style="background-image: url(static/picture/home/banner/main-slider-1-1.jpg);">
						</div>
						<div class="main-slider__shape-1">
							<img src="static/picture/home/main-slider-shape-1.png" alt="">
						</div>
						<div class="main-slider__shape-2">
							<img src="static/picture/home/main-slider-shape-2.png" alt="">
						</div>
						<div class="main-slider__shape-3">
							<img src="static/picture/home/main-slider-shape-3.png" alt="">
						</div>
						<div class="container">
							<div class="row">
								<div class="col-xl-12">
									<div class="main-slider__content">
										<!-- 智能焊接云系统 iCloudWeld -->
										<p><span v-if="isShow">{{ $t('home.banner_cloud_title') }} </span> iCloudWeld </p>
										<h2>{{ $t('home.banner_cloud_desc') }}</h2> <!-- 助力焊接企业数字化转型，打造焊接新模式 -->
										<div class="main-slider__btn-video-box">
											<div class="main-slider__btn-box">
												<a @click="handleRouter('weldCloud','weldCloud')"
													class="thm-btn main-slider__btn">{{ $t('home.learn_more') }}</a> <!-- 了解更多 -->
											</div>
											<div class="main-slider__video-link">
												<!-- href="javascript:;" class="video-popup" -->
												<!-- <a @click="handleVideo('static/video/home1.mp4')">
													<div class="main-slider__video-icon">
														<span class="fa fa-play"></span>
														<i class="ripple"></i>
													</div>
												</a> -->
												<!-- <h3 class="main-slider__video-text" style="display: none;">Watch
													<br> how it works
												</h3> -->
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="swiper-slide">
						<div class="image-layer"
							style="background-image: url(static/picture/home/banner/main-slider-1-2.jpg);">
						</div>
						<!-- /.image-layer -->
						<div class="main-slider__shape-1">
							<img src="static/picture/home/main-slider-shape-1.png" alt="">
						</div>
						<div class="main-slider__shape-2">
							<img src="static/picture/home/main-slider-shape-2.png" alt="">
						</div>
						<div class="main-slider__shape-3">
							<img src="static/picture/home/main-slider-shape-3.png" alt="">
						</div>
						<div class="container">
							<div class="row">
								<div class="col-xl-12">
									<div class="main-slider__content">
										<!-- 压力容器焊接管理系统 VMES -->
										<p><span v-if="isShow">{{ $t('home.banner_vmes_title') }} </span> VMES </p> 
										<h2>{{ $t('home.banner_vmes_desc') }}</h2> <!-- 让焊接企业工艺、焊接生产更高效监管协同 -->
										<div class="main-slider__btn-video-box">
											<div class="main-slider__btn-box">
												<a @click="handleRouter('productSoftware','pressureVessel')"
													class="thm-btn main-slider__btn">{{ $t('home.learn_more') }}</a> <!-- 了解更多 -->
											</div>
											<div class="main-slider__video-link">
												<!-- <a href="javascript:;" class="video-popup"> -->
												<!-- <a @click="handleVideo('static/video/home.mp4')">
													<div class="main-slider__video-icon">
														<span class="fa fa-play"></span>
														<i class="ripple"></i>
													</div>
												</a> -->
												<!-- <h3 class="main-slider__video-text">Watch <br> how it works</h3> -->
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="swiper-slide">
						<div class="image-layer"
							style="background-image: url(static/picture/home/banner/main-slider-1-3.jpg);">
						</div>
						<div class="main-slider__shape-1">
							<img src="static/picture/home/main-slider-shape-1.png" alt="">
						</div>
						<div class="main-slider__shape-2">
							<img src="static/picture/home/main-slider-shape-2.png" alt="">
						</div>
						<div class="main-slider__shape-3">
							<img src="static/picture/home/main-slider-shape-3.png" alt="">
						</div>
						<div class="container">
							<div class="row">
								<div class="col-xl-12">
									<div class="main-slider__content">
										 <!-- 钢结构焊接管理系统 SMES -->
										<p><span v-if="isShow">{{ $t('home.banner_smes_title') }} </span>SMES</p> <!-- 钢结构焊接管理系统 SMES -->
										<h2>{{ $t('home.banner_smes_desc') }}</h2> <!-- 助力焊接企业优化焊接生产资料，降本增效 -->
										<div class="main-slider__btn-video-box">
											<div class="main-slider__btn-box">
												<a @click="handleRouter('productSoftware','steelStructure')"
													class="thm-btn main-slider__btn">{{ $t('home.learn_more') }}</a> <!-- 了解更多 -->
											</div>
											<div class="main-slider__video-link">
												<!-- <a href="javascript:;" class="video-popup"> -->
												<!-- <a @click="handleVideo('static/video/home.mp4')">
													<div class="main-slider__video-icon">
														<span class="fa fa-play"></span>
														<i class="ripple"></i>
													</div>
												</a> -->
												<!-- <h3 class="main-slider__video-text">Watch <br> how it works</h3> -->
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>

				<!-- If we need navigation buttons -->
				<div class="swiper-pagination" id="main-slider-pagination"></div>

			</div>
		</section>


		<!--系统框架图-->
		<section class="get-to-know" style="padding: 5rem 0 1.5rem;">
			<div class="container">
				<div class="services-three__top">
					<div class="row">
						<div class="col-xl-6 col-lg-6">
							<div class="services-three__top-left">
								<div class="section-title text-left">
									<div class="section-title__tagline-box">
										<span class="section-title__tagline">SYSTEM COMPOSITION</span> <!-- SYSTEM COMPOSITION -->
										<div class="section-title-shape">
											<img src="static/image/section-title-shape.png" alt="">
										</div>
									</div>
									<h2 class="section-title__title">{{ $t('home.system_composition_title') }}</h2> <!-- 奥太智能焊接云系统组成 -->
								</div>
							</div>
						</div>
						<div class="col-xl-6 col-lg-6">
							<div class="services-three__top-right">
								<p class="services-three__top-text">
									{{ $t('home.system_composition_desc') }}</p> <!-- 从企业全业务场景的管理需求入手... -->
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-xl-8 col-lg-12 know_img">
						<!-- <img  src="static/picture/home/atkjt02.png" style=" max-width: 100%;" alt=""> -->
						<div class="get-to-know__left wow slideInLeft" data-wow-delay="100ms" data-wow-duration="2500ms" style="visibility: visible; animation-duration: 2500ms; animation-delay: 100ms; animation-name: slideInLeft;">
							<!-- <img :src="static/picture/home/framework/atkjt02.png" style=" max-width: 100%;" alt=""> -->
							 <img :src="getImagePath('atkjt02.png')" style=" max-width: 100%;" alt="">
							<div class="get-to-know-shape-1">
								<img src="static/picture/home/get-to-know-shape-1.png" alt="">
							</div>
						</div>
					</div>
					<div class="col-xl-4 col-lg-12">
						<div class="get-to-know__right">
							<div class="section-title text-left" style="display: none;">
								<div class="section-title__tagline-box">
									<span class="section-title__tagline">{{ $t('home.system_framework_tagline') }}</span> <!-- SYSTEM FRAMEWORK -->
									<div class="section-title-shape">
										<img src="static/image/section-title-shape.png" alt="">
									</div>
								</div>
								<h2 class="section-title__title" style="font-size: var(--font-size-30);">
									{{ $t('home.system_framework_title') }}</h2> <!-- 系统架构 -->
							</div>
							<ul class="list-unstyled get-to-know__points">
								<li>
									<div class="icon">
										<span class="icon-check" style="color: #237DB9;"></span>
									</div>
									<div class="text">
										<span style="color: #237DB9;font-weight: bold;font-size: 20px;">
											{{ $t('home.arch_equipment_label') }}:  <!-- 车间设备： -->
										</span>
										<p>{{ $t('home.arch_equipment_desc') }}</p> <!-- 支持奥太及其它品牌的焊机入网； -->
									</div>
								</li>

								<li>
									<div class="icon">
										<span class="icon-check" style="color: #15AA96;"></span>
									</div>
									<div class="text">
										<span style="color: #15AA96;font-weight: bold;font-size: 20px;">
											{{ $t('home.arch_network_label') }}:  <!-- 网络传输： -->
										</span>
										<p>{{ $t('home.arch_network_desc') }}</p> <!-- 支持4G/5G移动网络... -->
									</div>
								</li>
								<li>
									<div class="icon">
										<span class="icon-check" style="color: #9BB955;"></span>
									</div>
									<div class="text">
										<span style="color: #9BB955;font-weight: bold;font-size: 20px;">
											{{ $t('home.arch_app_label') }}:  <!-- 系统应用： -->
										</span>
										<p>{{ $t('home.arch_app_desc') }}</p> <!-- 实现人、机、料、法、环、测全面管理... -->
									</div>
								</li>

								<li>
									<div class="icon">
										<span class="icon-check" style="color: #F19B14;"></span>
									</div>
									<div class="text">
										<span style="color: #F19B14;font-weight: bold;font-size: 20px;">
											{{ $t('home.arch_integration_label') }}:  <!-- 系统集成： -->
										</span>
										<p>{{ $t('home.arch_integration_desc') }}</p> <!-- 提供标准信息化接口... -->
									</div>
								</li>
								<li style="display: none;">
									<div class="icon">
										<span class="icon-check" style="color: #F19B14;"></span>
									</div>
									<div class="text">
										<span style="color: #F19B14;font-weight: bold;font-size: 20px;">
											{{ $t('home.arch_deploy_label') }}:  <!-- 系统部署： -->
										</span>
										<p>{{ $t('home.arch_deploy_desc') }}</p> <!-- 支持奥太专有云... -->
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</section>

		<!--Project Page One Start-->
		<section class="" style="padding-top: 50px;">
			<div class="container">
				<div class="row">
					<div class="col-xl-4 col-lg-4 wow fadeInUp" data-wow-delay="100ms">
						<div class="project-one__single">
							<div class="project-one__img">
					  			<img src="static/picture/home/gnqf/cj.jpg" alt="">
							</div>
							<div class="project-one__content">
								<div class="pricing__icon">
									<img src="static/picture/home/kk11.png" style="float: left;height: 70px;" alt="">
									<h2 class="pricing__rate">{{ $t('home.scene_workshop_title') }}<span></span></h2> <!-- 焊接车间 -->
								</div>
								<h3 class="project-one__title"><a href="#">{{ $t('home.scene_workshop_desc') }}</a></h3> <!-- 实现焊接车间设备网络化改造 -->
								<div class="clearfix"></div>
							</div>
						</div>
					</div>
					 <div class="col-xl-4 col-lg-4 wow fadeInUp" data-wow-delay="100ms">
					 	<div class="project-one__single">
					 		<div class="project-one__img">
					  			<img src="static/picture/home/gnqf/gc.jpg" alt="">
					 		</div>
					 		<div class="project-one__content">
					 			<div class="pricing__icon">
					 				<img src="static/picture/home/kk14.png" style="float: left;height: 70px;" alt="">
					 				<h2 class="pricing__rate">{{ $t('home.scene_factory_title') }}<span></span></h2> <!-- 焊接工厂 -->
					 			</div>
					 			<h3 class="project-one__title"><a href="#">{{ $t('home.scene_factory_desc') }}</a></h3> <!-- 助力企业实现焊接工厂信息化转型升级 -->
					 			<div class="clearfix"></div>
					 		</div>
					 	</div>
					 </div>
					  <div class="col-xl-4 col-lg-4 wow fadeInUp" data-wow-delay="100ms">
					  	<div class="project-one__single">
					  		<div class="project-one__img">
					  			<img src="static/picture/home/gnqf/mes.png" alt="">
					  		</div>
					  		<div class="project-one__content">
					  			<div class="pricing__icon">
					  				<img src="static/picture/home/kk15.png" style="float: left;height: 70px;" alt="">
					  				<h2 class="pricing__rate">{{ $t('home.scene_mes_title') }}<span></span></h2> <!-- 焊接MES -->
					  			</div>
					  			<h3 class="project-one__title"><a href="#">{{ $t('home.scene_mes_desc') }}</a></h3> <!-- 为用户提供智能化的综合焊接服务平台 -->
					  			<div class="clearfix"></div>
					  		</div>
					  	</div>
					  </div>
				</div>
			</div>
		</section>


		<!--功能区分-->
		<section class="pricing" v-if="false" style="display: none;">
			<div class="container">
					<div class="row">
						<div class="col-xl-4 col-lg-4">
							<!--Pricing Single-->
							<div class="pricing__single">
								<div class="pricing__icon">
									<h2 class="pricing__rate" style="float: left;"> {{ $t('home.feat_workshop_title') }} <!-- 焊接车间 --><span></span></h2>
									<img src="static/picture/home/kk11.png" style="float: right;height: 50px;" alt="">
								</div>
								<div class="clearfix"></div>
								<h3 class="pricing__title">{{ $t('home.feat_workshop_desc') }} <!--实现焊接车间设备网络化改造 --></h3>
								<div class="pricing__service">
									<p class="pricing__service-title" style="display: none;"> {{ $t('home.Main_functions') }}: <!-- 主要功能 --></p>
									<ul class="list-unstyled pricing__service-list">
										<li>
											<div class="icon">
												<span class="icon-tick"></span>
											</div>
											<div class="text">
												<p>{{ $t('home.feat_workshop_item_1') }} <!-- 实现所有品牌焊接设备联网改造；--></p>
											</div>
										</li>
										<li>
											<div class="icon">
												<span class="icon-tick"></span>
											</div>
											<div class="text">
												<p>{{ $t('home.feat_workshop_item_2') }} <!-- 实现设备开机时长、焊接时长自动统计；--></p>
											</div>
										</li>
										<li>
											<div class="icon">
												<span class="icon-tick"></span>
											</div>
											<div class="text">
												<p>{{ $t('home.feat_workshop_item_3') }} <!-- 实时监控焊机运行状态，超范围焊接系统自动报警；--></p>
											</div>
										</li>
										<li>
											<div class="icon">
												<span class="icon-tick"></span>
											</div>
											<div class="text">
												<p>{{ $t('home.feat_workshop_item_4') }} <!-- 一键导出焊接成本报告、焊接实时曲线及报警记录；--></p>
											</div>
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div class="col-xl-4 col-lg-4">
							<!--Pricing Single-->
							<div class="pricing__single">
								<div class="pricing__icon">
									<h2 class="pricing__rate" style="float: left;">
										<!-- 焊接工厂  -->
										 {{ $t('home.feat_factory_title') }}
									<span></span></h2>
									<img src="static/picture/home/kk14.png" style="float: right;height: 50px;" alt="">
								</div>
								<div class="clearfix"></div>
								<h3 class="pricing__title">
									<!-- 助力企业实现焊接工厂信息化转型升级 -->
									 {{ $t('home.feat_factory_desc') }}
								</h3>
								<div class="pricing__service">
									<ul class="list-unstyled pricing__service-list">
										<li>
											<div class="icon">
												<span class="icon-tick"></span>
											</div>
											<div class="text">
												<p>
													<!-- 实现PQR、WPS的焊接工艺流程化、电子化管理； -->
													 {{ $t('home.feat_factory_item_1') }}
												</p>
											</div>
										</li>
										<li>
											<div class="icon">
												<span class="icon-tick"></span>
											</div>
											<div class="text">
												<p>
													<!-- 实现焊接任务工单信息化管理与焊接生产流程的数字化改造； -->
													 {{ $t('home.feat_factory_item_2') }}
												</p>
											</div>
										</li>
										<li>
											<div class="icon">
												<span class="icon-tick"></span>
											</div>
											<div class="text">
												<p>
													<!-- 完成焊工信息档案、持证资质、探伤合格率、工艺符合度、焊工业绩等数字化管理； -->
													 {{ $t('home.feat_factory_item_3') }}
												</p>
											</div>
										</li>
										<li>
											<div class="icon">
												<span class="icon-tick"></span>
											</div>
											<div class="text">
												<p>
													<!-- 实现焊材库领/退/还信息化管理; -->
													 {{ $t('home.feat_factory_item_4') }}
												</p>
											</div>
										</li>
										<li>
											<div class="icon">
												<span class="icon-tick"></span>
											</div>
											<div class="text">
												<p>
													<!-- 一键生成各类统计分析报表； -->
													 {{ $t('home.feat_factory_item_5') }}
												</p>
											</div>
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div class="col-xl-4 col-lg-4">
							<!--Pricing Single-->
							<div class="pricing__single">
								<div class="pricing__icon">
									<h2 class="pricing__rate" style="float: left;">
										<!-- 焊接MES -->
										 {{ $t('home.feat_mes_title') }} 
									<span></span></h2>
									<img src="static/picture/home/kk15.png" style="float: right;height: 50px;" alt="">
								</div>
								<div class="clearfix"></div>
								<h3 class="pricing__title">
									<!-- 为用户提供智能化的综合焊接服务平台 -->
									 {{ $t('home.feat_mes_desc') }}
								</h3>
								<div class="pricing__service">
									<ul class="list-unstyled pricing__service-list">
										
										<li>
											<div class="icon">
												<span class="icon-tick"></span>
											</div>
											<div class="text">
												<p>
													<!-- 完成焊接过程中的焊工、焊机、焊材、工艺、质检一体化管理； -->
													  {{ $t('home.feat_mes_item_1') }}
												</p>
											</div>
										</li>
										
										<li>
											<div class="icon">
												<span class="icon-tick"></span>
											</div>
											<div class="text">
												<p>
													<!-- 实时监控焊接过程中各环节的工艺数据，生成焊缝工艺符合度报告； -->
													 {{ $t('home.feat_mes_item_2') }}
												</p>
											</div>
										</li>
										<li>
											<div class="icon">
												<span class="icon-tick"></span>
											</div>
											<div class="text">
												<p>
													<!-- 焊接生产过程信息化，全程监控，焊接数据可追溯; -->
													 {{ $t('home.feat_mes_item_3') }}
												</p>
											</div>
										</li>
										<li>
											<div class="icon">
												<span class="icon-tick"></span>
											</div>
											<div class="text">
												<p>
													<!-- 自动生成电子化施焊记录单； -->
													  {{ $t('home.feat_mes_item_4') }}
												</p>
											</div>
										</li>
										<li>
											<div class="icon">
												<span class="icon-tick"></span>
											</div>
											<div class="text">
												<p>
													<!-- 与企业PLM、ERP、OA等系统互联互通，实现数据共享； -->
													 {{ $t('home.feat_mes_item_5') }}
												</p>
											</div>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
			</div>
		</section>


		<!--系统框架-->
		<section class="we-help">
			<div class="container">
				<div class="we-help__inner" style="padding-top: 50px;">
					<div class="section-title text-center">
						<div class="section-title__tagline-box">
							<span class="section-title__tagline">{{ $t('home.func_framework_tagline') }}</span> <!-- SYSTEM FRAMEWORK -->
							<div class="section-title-shape">
								<img src="static/image/section-title-shape.png" alt="">
							</div>
						</div>
						<h2 class="section-title__title">{{ $t('home.func_framework_title') }}</h2> <!-- 奥太智能焊接云功能框架 -->
					</div>
					<div class="row">
						<!-- <img style="max-width: 100%" src="static/picture/home/framework/atkjt01.png" alt=""> -->
						 <img style="max-width: 100%" :src="getImagePath('atkjt01.png')" alt="" />
					</div>
				</div>
			</div>
		</section>


		<!--建设目标-->
		<section class="we-help">
			<div class="container">
				<div class="we-help__inner" style="padding-top: 50px;">
					<div class="section-title text-center">
						<div class="section-title__tagline-box">
							<span class="section-title__tagline">{{ $t('home.targets_tagline') }}</span> <!-- SYSTEM TARGETS -->
							<div class="section-title-shape">
								<img src="static/image/section-title-shape.png" alt="">
							</div>
						</div>
						<h2 class="section-title__title">{{ $t('home.targets_title') }}</h2> <!-- 奥太智能焊接云建设目标 -->
					</div>
					<div class="row">
						<div class="col-xl-12 col-lg-12">
							<div class="we-help__right">
								<div class="we-help__img wow slideInRight" data-wow-delay="100ms"
									data-wow-duration="2500ms">
									<!-- <img src="static/picture/home/framework/ztgh.png" style=" max-width: 100%;" alt=""> -->
									  <img style="max-width: 100%" :src="getImagePath('ztgh.png')" alt="" />
								</div>
							</div>
						</div>
						<div class="col-xl-4 col-lg-4" style="display: none;">
							<div class="we-help__left">
								<p class="we-help__text-2"><span class="icon-check" style="color: #15AA96;"></span>
									{{ $t('home.target_item_1') }}</p> <!-- 实现车间所有焊接设备数字化改造... -->
								<p class="we-help__text-2"><span class="icon-check" style="color: #15AA96;"></span>
									{{ $t('home.target_item_2') }}</p> <!-- 规范焊接过程中参与的焊工... -->
								<p class="we-help__text-2"><span class="icon-check" style="color: #15AA96;"></span>
									{{ $t('home.target_item_3') }} <!-- 实现车间生产计划管理... -->
								</p>
								<p class="we-help__text-2"><span class="icon-check" style="color: #15AA96;"></span>
									{{ $t('home.target_item_4') }}</p> <!-- 支持与PLM、ERP、OA等系统对接... -->
							</div>
						</div>

					</div>
				</div>
			</div>
		</section>

		<!--核心功能-->
		<section class="services-three service-three--no-pb" style="padding:7rem 0 1.5rem;">
			<div class="container">
				<div class="services-three__top">
					<div class="row">
						<div class="col-xl-7 col-lg-7">
							<div class="services-three__top-left">
								<p class="services-three__top-text">
									{{ $t('home.services_desc') }}</p> <!-- 面向企业的全业务场景... -->
							</div>
						</div>

						<div class="col-xl-5 col-lg-5">
							<div class="services-three__top-right">
								<div class="section-title text-left">
									<div class="section-title__tagline-box">
										<span class="section-title__tagline">{{ $t('home.services_tagline') }}</span> <!-- SERVICES WE'RE PROVIDING -->
										<div class="section-title-shape">
											<img src="static/image/section-title-shape.png" alt="">
										</div>
									</div>
									<h2 class="section-title__title">{{ $t('home.services_title') }}</h2> <!-- 我们为客户提供的核心功能 -->
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="services-three__bottom">
					<div class="row">
						<div class="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="100ms"
							style="visibility: visible; animation-delay: 100ms; animation-name: fadeInUp;">
							<!--Services Three Single-->
							<div class="services-three__single">
								<div class="services-three__img">
									<!-- <img src="static/picture/home/bg22.jpg" alt=""> -->
									<img src="static/picture/home/function/scgk.jpg" alt="">
								</div>
								<div class="services-three__content">
									<div class="services-three__icon">
										<span class="icon-coding"></span>
									</div>
                                    <!-- 注意：这里包含 <br>，必须使用 v-html -->
									<h3 class="services-three__title" ><a v-html="$t('home.service_mes_title')"></a></h3> <!-- 生产管控<br>MES -->
									<p class="services-three__text" v-if="isShow">{{ $t('home.service_mes_desc') }}</p> <!-- 管控生产计划与工单... -->
									<!-- <div class="services-three__learn-more">
										<a href="product-development.html">了解更多<i
												class="fa fa-long-arrow-alt-right"></i></a>
									</div> -->
								</div>
							</div>
						</div>
						<div class="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="200ms">
							<!--Services Three Single-->
							<div class="services-three__single">
								<div class="services-three__img">
									<!-- <img src="static/picture/home/bg24.jpg" alt=""> -->
									<img src="static/picture/home/function/gygl.jpg" alt="">
								</div>
								<div class="services-three__content">
									<div class="services-three__icon">
										<span class="icon-design-thinking"></span>
									</div>
                                    <!-- 注意：这里包含 <br>，必须使用 v-html -->
									<h3 class="services-three__title" ><a v-html="$t('home.service_wps_title')"></a></h3> <!-- 工艺管理 <br>WPS -->
									<p class="services-three__text" v-if="isShow">{{ $t('home.service_wps_desc') }}</p> <!-- 高效协同监管焊接工艺准确执行... -->
									<!-- <div class="services-three__learn-more">
										<a href="ui-ux-designing.html">了解更多<i
												class="fa fa-long-arrow-alt-right"></i></a>
									</div> -->
								</div>
							</div>
						</div>
						<div class="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="300ms">
							<!--Services Three Single-->
							<div class="services-three__single">
								<div class="services-three__img">
									<!-- <img src="static/picture/home/bg27.jpg" alt=""> -->
									<img src="static/picture/home/function/zlgl.jpg" alt="">
								</div>
								<div class="services-three__content">
									<div class="services-three__icon">
										<span class="icon-technology"></span>
									</div>
                                    <!-- 注意：这里包含 <br>，必须使用 v-html -->
									<h3 class="services-three__title" ><a v-html="$t('home.service_qms_title')"></a></h3> <!-- 质量监管 <br>QMS -->
									<p class="services-three__text" v-if="isShow">{{ $t('home.service_qms_desc') }}</p> <!-- 建立完整的质量数据追溯链... -->
									<!-- <div class="services-three__learn-more">
										<a href="digital-marketing.html">了解更多<i
												class="fa fa-long-arrow-alt-right"></i></a>
									</div> -->
								</div>
							</div>
						</div>
						<div class="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="400ms">
							<!--Services Three Single-->
							<div class="services-three__single">
								<div class="services-three__img">
									<!-- <img src="static/picture/home/bg23.jpg" alt=""> -->
									<img src="static/picture/home/function/sczy.jpg" alt="">
								</div>
								<div class="services-three__content">
									<div class="services-three__icon">
										<span class="icon-content"></span>
									</div>
                                    <!-- 注意：这里包含 <br>，必须使用 v-html -->
									<h3 class="services-three__title" ><a v-html="$t('home.service_wrs_title')"></a></h3> <!-- 生产资源 <br>WRS -->
									<p class="services-three__text" v-if="isShow">{{ $t('home.service_wrs_desc') }}</p> <!-- 合理调度人员、设备、焊材等参与角色... -->
									<!-- <div class="services-three__learn-more">
										<a href="content-management.html">了解更多<i
												class="fa fa-long-arrow-alt-right"></i></a>
									</div> -->
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- 解决方案 -->
		<section class="delivering-it" style="display: block;">
			<div class="container">
				<div class="delivering-it__top">
					<div class="row">
						<div class="col-xl-7 col-lg-7">
							<div class="delivering-it__top-left">
								<div class="section-title text-left">
									<div class="section-title__tagline-box">
										<span class="section-title__tagline">{{ $t('home.solutions_header_tagline') }}</span> <!-- INDUSTRY SOLUTIONS -->
										<div class="section-title-shape">
											<img src="static/image/section-title-shape.png" alt="">
										</div>
									</div>
									<div class="section-title__title" style="font-size: var(--font-size-40);">
										{{ $t('home.solutions_header_title') }} <!-- 山东奥太30年深耕焊接行业... -->
									</div>
								</div>
							</div>
						</div>
						<div class="col-xl-5 col-lg-5">
							<div class="delivering-it__top-right">
								<p class="delivering-it__top-text" style="font-size: var(--font-size-20);">
									{{ $t('home.solutions_header_desc') }} <!-- 聚焦压力容器、长输管道... -->
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- <img src="static/123.png" alt=""> -->
			<div class="ver ver_box" style="height: 800px;">
				<div class="ver_l" style="height: 100%;">
					<div class="ver_l1" style="height: 100%; display: flex; flex-direction: column;  justify-content: space-evenly;">
						<div data-tab="#home_pressure" class="ver_item home_pressure_li ver_active">
							{{ $t('home.sol_cat_pressure') }} <!-- 压力容器 -->
						</div>
						<div data-tab="#home_ship" class="ver_item home_ship_li">
							{{ $t('home.sol_cat_ship') }} <!-- 船舶 -->
						</div>
						<div data-tab="#home_structure" class="ver_item home_structure_li">
							{{ $t('home.sol_cat_structure') }} <!-- 钢结构 -->
						</div>
						<div data-tab="#home_make" class="ver_item home_make_li">
							{{ $t('home.sol_cat_machinery') }} <!-- 工程机械 -->
						</div>
						<div data-tab="#home_training" class="ver_item home_training_li">
							{{ $t('home.sol_cat_training') }} <!-- 焊培 -->
						</div>
						<div data-tab="#home_machine" class="ver_item home_machine_li">
							{{ $t('home.sol_cat_coal') }} <!-- 煤机 -->
						</div>
						
						<div data-tab="#home_piping" class="ver_item home_piping_li">
							{{ $t('home.sol_cat_piping') }} <!-- 长输管道 -->
						</div>
						<!-- <div data-tab="#home_nuclearPower" class="ver_item home_nuclearPower_li">
							核电
						  </div> -->
					</div>
				</div>
				<div class="ver_r">
					<!-- 压力容器 -->
					<div class="r_act r_active r_act_pressure" id="home_pressure"
						style="background-image: url(static/picture/home/solutions/pressure.jpg);">
						<div class="fnt_38 vertical_tit">{{ $t('home.sol_pressure_title') }}</div> <!-- 压力容器解决方案 -->
						<div class="fnt_16 vertical_summary">
							<!-- 焊接工艺与焊接过程融合协同... -->
							{{ $t('home.sol_pressure_desc') }} <!-- 压力容器行业解决方案是在奥太智能焊接云系统的基础上... -->
						</div>
						<ul class="icon_flx">
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic0.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_welding_process') }}</div> <!-- 焊接工艺 -->
							</li>
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic2.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_task_order') }}</div> <!-- 任务工单 -->
							</li>
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic3.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_welder_operation') }}</div> <!-- 焊工施焊 -->
							</li>
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic4.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_quality_inspection') }}</div> <!-- 质量检验 -->
							</li>
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic5.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_completion_data') }}</div> <!-- 完工资料 -->
							</li>
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic6.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_data_report') }}</div> <!-- 数据报表 -->
							</li>
						</ul>
						<a class="obtain" @click="handleRouter('solutionDetail','pressureVessel')">{{ $t('home.sol_get_plan') }}</a> <!-- 获取方案 -->
						<!-- <div class="fnt_16 anli_tit">客户案例</div>
						<div class="anli">
							<img src="static/picture/home/solutions/brand-1-7.png" alt="">
							<img src="static/picture/home/solutions/brand-1-8.png" alt="">
							<img src="static/picture/home/solutions/brand-1-13.png" alt="">
						</div> -->
					</div>
					<!-- 船舶 -->
					<div class="r_act r_act_ship" id="home_ship"
						style="background-image: url(static/picture/home/solutions/ship.jpg);">
						<div class="fnt_38 vertical_tit">{{ $t('home.sol_ship_title') }}</div> <!-- 船舶解决方案 -->
						<div class="fnt_16 vertical_summary">
							<!-- 钢结构焊接管理系统是一套综合性的管理系统... -->
							{{ $t('home.sol_ship_desc') }} <!-- 船舶解决方案是随着物联网、云计算等技术的发展... -->
						</div>
						<ul class="icon_flx">
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic3.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_welder_operation') }}</div> <!-- 焊工施焊 -->
							</li>
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic6.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_data_report') }}</div> <!-- 数据报表 -->
							</li>
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic1.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_welding_data') }}</div> <!-- 焊接数据 -->
							</li>
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic11.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_welding_equipment') }}</div> <!-- 焊接设备 -->
							</li>
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic12.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_welder_management') }}</div> <!-- 焊工管理 -->
							</li>
						</ul>
						<a class="obtain" @click="handleRouter('solutionDetail','ship')">{{ $t('home.sol_get_plan') }}</a> <!-- 获取方案 -->
					
					</div>
					<!-- 钢结构 -->
					<div class="r_act r_act_structure" id="home_structure"
						style="background-image: url(static/picture/home/solutions/structure.jpg);">
						<div class="fnt_38 vertical_tit">{{ $t('home.sol_structure_title') }}</div> <!-- 钢结构解决方案 -->
						<div class="fnt_16 vertical_summary">
							<!-- 钢结构焊接管理系统是一套综合性的管理系统... -->
							{{ $t('home.sol_structure_desc') }} <!-- 钢结构焊接智能制造解决方案集成了焊接设备... -->
						</div>
						<ul class="icon_flx">
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic0.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_welding_process') }}</div> <!-- 焊接工艺 -->
							</li>
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic10.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_weld_map') }}</div> <!-- 焊缝地图 -->
							</li>
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic1.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_welding_data') }}</div> <!-- 焊接数据 -->
							</li>
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic11.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_welding_equipment') }}</div> <!-- 焊接设备 -->
							</li>
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic12.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_welding_personnel') }}</div> <!-- 焊接人员 -->
							</li>
						</ul>
						<a class="obtain" @click="handleRouter('solutionDetail','steelStructureScheme')">{{ $t('home.sol_get_plan') }}</a> <!-- 获取方案 -->
						<!-- <div class="fnt_16 anli_tit">客户案例</div>
						<div class="anli">
							<img src="static/picture/home/solutions/brand-1-10.png" alt="">
							<img src="static/picture/home/solutions/brand-1-14.png" alt="">
						</div> -->
					</div>
					<!-- 机械制造 -->
					<div class="r_act" id="home_make"
						style="background-image: url(static/picture/home/solutions/make.jpg);">
						<div class="fnt_38 vertical_tit">{{ $t('home.sol_machinery_title') }}</div> <!-- 机械制造解决方案 -->
						<div class="fnt_16 vertical_summary">
							<!-- 机械制造智能焊接MES系统是在奥太智能焊接云系统基础上... -->
							{{ $t('home.sol_machinery_desc') }} <!-- 机械制造行业解决方案是在奥太智能焊接云系统基础上... -->
						</div>
						<ul class="icon_flx">
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic0.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_process_management') }}</div> <!-- 工艺管理 -->
							</li>
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic2.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_production_management') }}</div> <!-- 生产管理 -->
							</li>
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic4.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_quality_management') }}</div> <!-- 质量管理 -->
							</li>
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic8.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_cost_management') }}</div> <!-- 成本管理 -->
							</li>
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic1.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_material_management') }}</div> <!-- 焊材库管理 -->
							</li>
						</ul>
						<a class="obtain" @click="handleRouter('solutionDetail','machinery')">{{ $t('home.sol_get_plan') }}</a> <!-- 获取方案 -->
						<!-- <div class="fnt_16 anli_tit">客户案例</div>
						<div class="anli">
							<img src="static/picture/home/solutions/brand-1-1.png" alt="">
							<img src="static/picture/home/solutions/brand-1-3.png" alt="">
							<img src="static/picture/home/solutions/brand-1-5.png" alt="">
							<img src="static/picture/home/solutions/brand-1-6.png" alt="">
							<img src="static/picture/home/solutions/brand-1-12.png" alt="">
						</div> -->
					</div>
					<!-- 焊培 -->
					<div class="r_act r_act_training" id="home_training"
						style="background-image: url(static/picture/home/solutions/training.jpg);">
						<div class="fnt_38 vertical_tit">{{ $t('home.sol_training_title') }}</div> <!-- 焊培解决方案 -->
						<div class="fnt_16 vertical_summary">
							<!-- 智慧焊培管理系统建立企业级焊接业务管理平台... -->
							{{ $t('home.sol_training_desc') }} <!-- 焊培领域智能制造解决方案由奥太智能研发中心打造... -->
						</div>
						<ul class="icon_flx">
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic4-3.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_exam_process_mgmt') }}</div> <!-- 考试流程管理 -->
							</li>
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic9.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_exam_monitoring') }}</div> <!-- 考试过程监控 -->
							</li>
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic4-4.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_exam_data_report') }}</div> <!-- 考试数据报表 -->
							</li>
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic0.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_welding_proc_mgmt') }}</div> <!-- 焊接工艺管理 -->
							</li>
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic4-6.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_student_info_mgmt') }}</div> <!-- 学员信息管理 -->
							</li>
						</ul>
						<a class="obtain" @click="handleRouter('solutionDetail','weldTraining')">{{ $t('home.sol_get_plan') }}</a> <!-- 获取方案 -->
						<!-- <div class="fnt_16 anli_tit">客户案例</div>
						<div class="anli">
							<img src="static/picture/home/solutions/brand-1-4.png" alt="">
							<img src="static/picture/home/solutions/brand-1-11.png" alt="">
						</div> -->
					</div>
					<!-- 煤机 -->
					<div class="r_act r_act_machine" id="home_machine"
						style="background-image: url(static/picture/home/solutions/machine.jpg);">
						<div class="fnt_38 vertical_tit">{{ $t('home.sol_coal_title') }}</div> <!-- 煤机解决方案 -->
						<div class="fnt_16 vertical_summary">
							{{ $t('home.sol_coal_desc') }} <!-- 煤机领域智能制造解决方案由奥太智能研发中心打造... -->
						</div>
						<ul class="icon_flx">
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic12.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_welder_management') }}</div> <!-- 焊工管理 -->
							</li>
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic2.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_production_management') }}</div> <!-- 生产管理 -->
							</li>
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic4.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_quality_management') }}</div> <!-- 质量管理 -->
							</li>
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic8.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_cost_management') }}</div> <!-- 成本管理 -->
							</li>
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic6.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_data_report') }}</div> <!-- 数据报表 -->
							</li>
						</ul>
						<a class="obtain " @click="handleRouter('solutionDetail','coalMachine')">{{ $t('home.sol_get_plan') }}</a> <!-- 获取方案 -->
						<!-- <div class="fnt_16 anli_tit">客户案例</div>
						<div class="anli">
							<img src="static/picture/home/solutions/brand-1-17.png" alt="">
							<img src="static/picture/home/solutions/brand-1-16.png" alt="">
							<img src="static/picture/home/solutions/brand-1-15.png" alt="">
						</div> -->
					</div>
					
					<!-- 管道 -->
					<div class="r_act r_act_piping" id="home_piping"
						style="background-image: url(static/picture/home/solutions/piping.jpg);">
						<div class="fnt_38 vertical_tit">{{ $t('home.sol_piping_title') }}</div> <!-- 长输管道解决方案 -->
						<div class="fnt_16 vertical_summary">
							<!-- 管道自动焊远程在线分析系统是以焊接系统为中心... -->
							{{ $t('home.sol_piping_desc') }} <!-- 管道行业解决方案是以焊接系统为中心... -->
						</div>
						<ul class="icon_flx">
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic0.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_welding_process') }}</div> <!-- 焊接工艺 -->
							</li>
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic2.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_task_order') }}</div> <!-- 任务工单 -->
							</li>
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic3.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_welder_operation') }}</div> <!-- 焊工施焊 -->
							</li>
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic4.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_quality_inspection') }}</div> <!-- 质量检验 -->
							</li>
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic5.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_completion_data') }}</div> <!-- 完工资料 -->
							</li>
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic6.png" alt="">
								</div>
								<div class="fnt_16">{{ $t('home.feat_data_report') }}</div> <!-- 数据报表 -->
							</li>
						</ul>
						<a class="obtain" @click="handleRouter('solutionDetail','piping')">{{ $t('home.sol_get_plan') }}</a> <!-- 获取方案 -->
						<!-- <div class="fnt_16 anli_tit">客户案例</div>
						<div class="anli">
							<img src="static/picture/home/solutions/brand-1-2.png" alt="">
							<img src="static/picture/home/solutions/brand-1-9.png" alt="">
						</div> -->
					</div>


					<!-- 核电 -->
					<!-- <div class="r_act r_act_nuclearPower" id="home_nuclearPower" style="">
						<div class="fnt_38 vertical_tit">核电解决方案</div>
						<div class="fnt_16 vertical_summary">
							金蝶从企业的技术研发能力的构建...
						</div>
						<ul class="icon_flx">
							<li>
								<div class="vertical_img">
									<img src="static/picture/home/solutions/ic1.png" alt="">
								</div>
								<div class="fnt_16">成本管理</div>
							</li>
                            ...
						</ul>
						<a class="obtain" @click="handleRouter()">获取方案</a>
						<div class="fnt_16 anli_tit">客户案例</div>
						<div class="anli">
							<img src="static/picture/home/solutions/brand-1-1.png" alt="">
                            ...
						</div>
					</div> -->
				</div>
			</div>

		</section>
		<!--合作企业-->
		<section class="trusted-source" style="padding-top: 120px">
			<div class="container">
				<div class="trusted-source__inner wow fadeInUp" data-wow-delay="300ms">
					<div class="trusted-source__left" style="flex: 3;">
                        <!-- 注意：这里原代码有 <br>，语言包已拆分为 content 和 provider，此处手动组合或调整语言包结构。
                             根据提供的 zh_CN.js，trusted_source_content 不包含 <br>，trusted_source_provider 是单独一行。
                             为了保持原样换行，我们可以这样写： -->
						<h3 class="trusted-source__content">
                            {{ $t('home.trusted_source_content') }} <br> {{ $t('home.trusted_source_provider') }}
                        </h3> 
                        <!-- 原: 智能制造焊接数字化解决方案 <br> 优秀服务提供商 -->
					</div>
					<div class="trusted-source__icon" style="">
						<img src="static/picture/home/trusted-source-icon.png" alt="">
					</div>
					<div class="trusted-source__right" style="flex: 3;">
						<div class="trusted-source__contact-info">
							<p>{{ $t('home.trusted_source_contact_title') }}</p> <!-- 有任何问题请致电我们 -->
							<!-- href="tel:400-0531-772" -->
							<a><span> + </span>86-132-0531-8830</a>
						</div>
					</div>
				</div>
				<!-- 合作伙伴 -->
				<div class="we-help__inner" style="padding-top: 50px;">
					<div class="row" style="padding:0 150px ;">
						<img src="static/picture/home/custom/khlb.png" alt="" srcset="">
					</div>
					<!-- <el-carousel indicator-position="outside">
						<el-carousel-item >
							<img src="static/picture/home/custom/khlb1.png" alt="" srcset="">
						</el-carousel-item>
						<el-carousel-item>
							<img src="static/picture/home/custom/khlb2.png" alt="" srcset="">
						</el-carousel-item>
					</el-carousel> -->
				</div>
			</div>

			<div class="container" style="padding-top: 60px;display: none;">
				<div class="row">
					<div class="col-xl-12">
						<ul class="list-unstyled counter-one__list">
							<li class="counter-one__single wow fadeInUp" data-wow-delay="100ms">
								<div class="counter-one__icon">
									<span class="icon-work"></span>
								</div>
								<h3 class="odometer" data-count="30">30</h3>
								<p class="counter-one__title">{{ $t('home.stat_solutions') }}</p> <!-- 解决方案 -->
								<div class="counter-one__shadow">SOLUTIONS</div>
								<p class="counter-one__text" style="display: none;">Lorem ipsum is simply free text used
									by refring.</p>
							</li>
							<li class="counter-one__single wow fadeInUp" data-wow-delay="200ms">
								<div class="counter-one__icon">
									<span class="icon-technical-support"></span>
								</div>
								<h3 class="odometer" data-count="12800+">12800+</h3>
								<!-- <span class="counter-one__plus">+</span> -->
								<p class="counter-one__title">{{ $t('home.stat_equipment') }}</p> <!-- 入网设备 -->
								<div class="counter-one__shadow">EQUIPMENT</div>
								<p class="counter-one__text" style="display: none;">Lorem ipsum is simply free text used
									by refring.</p>
							</li>
							<li class="counter-one__single wow fadeInUp" data-wow-delay="300ms">
								<div class="counter-one__icon">
									<span class="icon-user"></span>
								</div>
								<h3 class="odometer" data-count="229+">229+</h3>
								<!-- <span class="counter-one__plus">+</span> -->
								<p class="counter-one__title">{{ $t('home.stat_clients') }}</p> <!-- 企业客户 -->
								<div class="counter-one__shadow">CLIENT</div>
								<p class="counter-one__text" style="display: none;">Lorem ipsum is simply free text used
									by refring.</p>
							</li>

							<li class="counter-one__single wow fadeInUp" data-wow-delay="300ms">
								<div class="counter-one__icon">
									<span class="icon-like"></span>
								</div>
								<h3 class="odometer" data-count="54">54</h3>
								<p class="counter-one__title">{{ $t('home.stat_honor') }}</p> <!-- 获得荣誉 -->
								<div class="counter-one__shadow">HONOR</div>
								<p class="counter-one__text" style="display: none;">Lorem ipsum is simply free text used
									by refring.</p>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</section>

		<el-dialog :visible.sync="dialogVisible">
			<video style="width: 900px;" autoplay="autoplay" loop="loop" :src="videoSrc" controls=""></video>
		</el-dialog>
	</div>
</template>
<script>

	import { MixinsList} from '@/mixins/mixins';
	export default {
		name: 'home',
		mixins: [MixinsList],
		components: {},
		data() {
			return {
				dialogVisible: false,
				videoSrc: "",

				
			}
		},
		created() {
			
		},
		mounted() {
			// console.log("路由信息", this.$route)
			// 确定选中的菜单
			$('.current').removeClass('current');
			$('.home_li').addClass('current');

			if ($(".thm-swiper__slider").length) {
				$(".thm-swiper__slider").each(function() {
					let elm = $(this);
					let options = elm.data('swiper-options');
					let thmSwiperSlider = new Swiper(elm, options);
				});
			}


			if ($(".ver_box").length) {
				$(".ver_box .ver_item").on("click", function(e) {
					e.preventDefault();
					var target = $($(this).attr("data-tab"));
					if ($(target).is(":visible")) {
						return false;
					} else {
						target
							.parents(".ver_box")
							.find(".ver_l1")
							.find(".ver_item")
							.removeClass("ver_active");
						$(this).addClass("ver_active");
						target
							.parents(".ver_box")
							.find(".ver_r")
							.find(".r_act")
							.fadeOut(0);
						target
							.parents(".ver_box")
							.find(".ver_r")
							.find(".r_act")
							.removeClass("r_active");
						$(target).fadeIn(100);
						$(target).addClass("r_active");
					}
				});
			}

			// if ($(".video-popup").length) {
			// 	$(".video-popup").magnificPopup({
			// 		type: "iframe",
			// 		mainClass: "mfp-fade",
			// 		removalDelay: 160,
			// 		preloader: true,

			// 		fixedContentPos: false
			// 	});
			// }

		},
		methods: {
			handleVideo(val) {
				this.videoSrc = val
				this.dialogVisible = true
			},
			handleRouter(val, type) {
				if (val && type) {
					const router = this.$router.resolve({
						path: val,
						query: {
							type: type
						}
					});
					window.open(router.href, '_blank')
					// this.$router.push({
					// 	path: val,
					// 	query: {
					// 		type: type
					// 	}
					// });
				} else {
                    // 国际化提示
					this.$message.warning(this.$t('header.tempUnavailable')); // 暂时无法查看！
				}

			},


			getImagePath(path) {
				// static/picture/home/framework/atkjt02.png
				var  url = ""
				if(this.$i18n.locale == 'zh_CN') {
					url = 'static/picture/home/framework/' + path
				} else if( this.$i18n.locale == 'en_US') {
					url = 'static/picture/home/framework/en/' + path
				} else if( this.$i18n.locale == 'ru_RU') {
					url = 'static/picture/home/framework/ru/' + path
				} else {
					url = 'static/picture/home/framework/' + path
				}
				return url;
			}
		}
	}
</script>

<style scoped>
    /* ... styles remain unchanged ... */
	@import '../../public/static/css/owl.carousel.min.css';
	@import '../../public/static/css/owl.theme.default.min.css';



	.swiper-slide {
		height: 100vh;
	}

	.container {
		max-width: 1600px !important;
	}

	.get-to-know__left {
		margin-right: 0;
	}

	.get-to-know__points .text {
		font-size: 18px;
	}

	.get-to-know__points li {
		align-items: baseline !important;
	}

	.trusted-source__contact-info {
		margin-left: 300px;
		color: #fff;
	}

	.vertical_img {
		width: 48px;
		height: 48px;
	}

	.vertical_img img {
		width: 48px;
		height: 48px;
	}

	.ver_item {
		cursor: pointer;
		/* margin-bottom: 40px; */
		font-size: 24px;
	}

	.we-help__inner {
		border-bottom: 0;
		padding: 80px 0;
	}

	.r_act {
		display: none;
	}

	.r_active {
		display: block;
	}

	::v-deep .el-dialog {
		background: transparent;

	}

	.anli img {
		box-shadow: 8px 8px 5px #ccc;
	}

	::v-deep .el-dialog__headerbtn .el-dialog__close {
		color: var(--notech-white) !important;
	}

	.obtain:hover {
		color: var(--notech-white);
		background: var(--notech-black);
	}

	.pricing__icon img {
		height: 120px;
	}

	.pricing__single {
		height: 100%;
		margin-bottom: 0;
	}

	.project-one__img {
		background-color: transparent;
	}
	.project-one__content{
		padding: 40px 20px ;
	}



	.know_img {
		display: flex;
    align-items: center;
	}
</style>